import * as Yup from 'yup'
import moment from 'moment'
import { useState, useEffect } from 'react'
import { useFormik } from 'formik'

import { Form } from './delay.styled'
import { DelayAPI } from '../../../api'
import { checkIsEmpty, Lookup } from '../../../utils'
import { MasterModal, Input, Alerts, ModalDel, InputSelect } from '../../../components'
import LogAPI from '../../../api/master-data/log'
import { messageErrorFormikLog } from '../../../utils/message'

const DelayModal = (props) => {
  const isEdit = props.edit
  const isDetail = props.detail
  const isDelete = props.delete
  const [delayType, setDelayType] = useState([])
  const [multiClick, setMultClick] = useState(0)
  const [showAlert, setAlert] = useState({ visible: false, msg: '', success: false, type: '' })

  const _insertDelay = async (data) => {
    try {
      const response = await DelayAPI.InsertDelay(data)
      if (response && response.result) {
        setAlert({
          msg: 'Add data has been successful',
          success: true,
          visible: true,
          type: 'insert',
        })
      } else {
        setAlert({
          msg: 'Delay data already exists',
          success: false,
          visible: true,
          type: 'insert',
        })
      }
    } catch (err) {
      console.log(err)
      return err
    }
  }

  const _updateDelay = async (data) => {
    try {
      const response = await DelayAPI.UpdateDelay(data)
      if (response && response.result) {
        setAlert({
          msg: 'Update data has been successful',
          success: true,
          visible: true,
          type: 'update',
        })
      } else {
        setAlert({
          msg: 'Delay data already exists',
          success: false,
          visible: true,
          type: 'update',
        })
      }
    } catch (err) {
      console.log(err)
      return err
    }
  }

  const _deleteDelay = async () => {
    try {
      const response = await DelayAPI.DeleteDelay(props.data.Id)
      if (response && response.result) {
        props.setDeleted(false)
        setAlert({
          msg: 'Delete data has been successful',
          success: true,
          visible: true,
          type: 'delete',
        })
      } else {
        setAlert({ msg: 'Cannot delete data', success: false, visible: true, type: 'delete' })
      }
    } catch (err) {
      console.log(err)
      return err
    }
  }

  const _getDelayType = async () => {
    try {
      const { data } = await DelayAPI.GetDelayType(0, 0, '[]')
      setDelayType(data)
    } catch (err) {
      return err
    }
  }

  const _close = () => {
    setMultClick(0)
    setAlert({ ...showAlert, visible: false })
    if (showAlert.success) {
      props.setModal(false)
      FormInput.resetForm()
    }
  }

  useEffect(() => {
    _getDelayType()
  }, [])

  const _deleteModal = () => (
    <div>
      <ModalDel
        submitDelete={_deleteDelay}
        deleteText='Are you sure to delete the data ?'
        toggleDialog={() => props.setModal(false)}
      />
    </div>
  )

  const FormInput = useFormik({
    enableReinitialize: true,
    initialValues: {
      Id: isEdit || isDetail ? props.data.Id : 0,
      Is_Active: isEdit || isDetail ? props.data.Is_Active : true,
      Code: isEdit || isDetail ? props.data.Delay_Code : 'DLCXXXX',
      Delay_Type_Code: isEdit || isDetail ? props.data.Delay_Type_Code : '',
      Delay_Description: isEdit || isDetail ? props.data.Delay_Description : '',
    },
    validationSchema: Yup.object({
      Id: Yup.number(),
      Code: Yup.string(),
      Is_Active: Yup.boolean(),
      Delay_Type_Code: Yup.string().required('Required*'),
      Delay_Description: Yup.string().required('Required*'),
    }),
    onSubmit: async (values, form) => {
      setMultClick(multiClick + 1)
      if (checkIsEmpty(values.Delay_Description)) {
        form.setValues({
          ...values,
          Delay_Description: '',
        })
      } else {
        let data = {}
        Object.keys(values)
          .filter(
            (val) =>
              val == 'Delay_Type_Code' ||
              val == 'Delay_Description' ||
              val == 'Is_Active' ||
              val == 'Id'
          )
          .forEach((vl) => {
            data[vl] = values[vl]
          })
        if (isEdit) {
          if (multiClick === 0) {
            _updateDelay(data)
          }
        } else {
          if (multiClick === 0) {
            _insertDelay(data)
          }
        }
      }
    },
  })

  const insertLog = async () => {
    const detail =
      Object.entries(FormInput.touched).length > 0
        ? messageErrorFormikLog(FormInput.errors)
        : Lookup.LOG_MESSAGE.NO_INPUT
    const dataInsert = {
      Timestamp: moment().toISOString(),
      Action: isEdit ? Lookup.LOG_ACTION.UPDATE : Lookup.LOG_ACTION.ADD,
      Module: Lookup.LOG_MODULE.MASTER_DATA,
      Submodule: Lookup.LOG_SUB_MODULE.MASTER_DELAY,
      Detail: detail,
      Logtype: Lookup.LOG_TYPE.SYSTEM_LOG,
      Errorlevel: Lookup.LOG_ERROR_LEVEL.ERROR,
      From: '',
      To: '',
      Refno: FormInput.values.Code,
    }

    if (
      (Object.entries(FormInput.touched).length === 0 && !isEdit) || //submit w/o touch field
      (Object.entries(FormInput.errors).length > 0 && multiClick === 0) // submit after touch field
    ) {
      const { data } = await LogAPI.PostDataLog(dataInsert)
      if (data && data.result) return data.result
    } else return false
  }

  return (
    <>
      {isDelete && _deleteModal()}
      {props.modal && (
        <MasterModal
          maxWidth='lg'
          width={35}
          add={!isDetail}
          title='Master Data'
          showModal={props.modal}
          handleClose={() => {
            FormInput.resetForm()
            props.setModal(false)
          }}
          subTitle={
            isEdit
              ? 'Edit Master Data Delay'
              : isDetail
                ? 'Detail Master Data Delay'
                : 'Add Master Data Delay'
          }
          handleSave={() => {
            insertLog()
            FormInput.handleSubmit()
          }}
        >
          <Form>
            <Input
              id='m_dly_code_txt'
              name='Code'
              form={FormInput}
              label='Delay Code'
              value={FormInput.values.Code}
              InputProps={{ readOnly: true }}
              inputProps={{
                tabIndex: 1,
              }}
            />
            <Input
              id='m_dly_desc_txt'
              form={FormInput}
              name='Delay_Description'
              label='Delay Description'
              InputProps={{ readOnly: isDetail }}
              value={FormInput.values.Delay_Description}
              inputProps={{
                tabIndex: 3,
              }}
            />
            {(isEdit || isDetail) && (
              <InputSelect
                id='m_dly_status_txt'
                label='Status'
                name='Is_Active'
                options={[
                  { text: 'Enable', value: true },
                  { text: 'Disable', value: false },
                ]}
                optionText='text'
                optionValueKey='value'
                readOnly={!isEdit}
                form={FormInput}
                tabIndex={5}
              />
            )}
          </Form>
          <Form>
            <InputSelect
              id='m_dly_type_txt'
              label='Delay Type'
              name='Delay_Type_Code'
              options={delayType}
              optionText='Delay_Type_Text'
              optionValueKey='Delay_Type_Code'
              readOnly={isDetail}
              form={FormInput}
              tabIndex={2}
            />
            {(isEdit || isDetail) && (
              <Input
                id='m_dly_modby_txt'
                label='Modified By'
                InputProps={{ readOnly: true }}
                value={props.data.Modified_By}
              />
            )}
            {(isEdit || isDetail) && (
              <Input
                id='m_dly_modon_txt'
                label='Modified On'
                InputProps={{ readOnly: true }}
                value={moment(props.data.Modified_Date).format('DD/MM/YYYY HH:mm:ss')}
              />
            )}
          </Form>
        </MasterModal>
      )}
      <Alerts
        type={showAlert.type}
        msg={showAlert.msg}
        close={() => _close()}
        open={showAlert.visible}
        success={showAlert.success}
      />
    </>
  )
}

export default DelayModal
